import { useTheme } from "@monolith-forensics/monolith-ui";

interface CircularProgressProps {
  percentage: string;
  size?: number;
  strokeWidth?: number;
  color?: string;
  fontSize?: number;
  compact?: boolean;
}

const CircularProgress = ({
  percentage,
  size = 16,
  strokeWidth = 2,
  color,
  fontSize = 12,
  compact = false,
}: CircularProgressProps) => {
  const theme = useTheme();
  if (
    percentage?.toLowerCase?.() === "not assigned" ||
    percentage?.toLowerCase?.() === "nothing assigned" ||
    percentage === undefined
  ) {
    if (compact) {
      return <span style={{ fontSize: fontSize, opacity: 0.7 }}>{"N/A"}</span>;
    }
    return (
      <span style={{ fontSize: fontSize, opacity: 0.7 }}>{percentage}</span>
    );
  }

  const numericPercentage = Number(percentage);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (numericPercentage / 100) * circumference;
  const circleColor =
    numericPercentage === 100
      ? "limegreen"
      : color || theme.palette.primary.main; // Green if 100%

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <span style={{ fontSize: fontSize }}>
        {Math.round(numericPercentage)}%
      </span>
      <svg height={size} width={size}>
        <circle
          stroke={theme.palette.divider}
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          stroke={circleColor}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          r={radius}
          cx={size / 2}
          cy={size / 2}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: "stroke-dashoffset 0.3s" }}
        />
      </svg>
    </div>
  );
};

export default CircularProgress;
